import { store } from "../store";
import permission from "../../src/store/modules/permission.js";
export default {
  async checkItem(menuId, permissionValue) {
    var code = await store.dispatch("permission/GetMenuPermission", menuId);
    console.log("code", code);
    return (code & permissionValue) > 0;
  },
  async checkEdit(route) {
    let item = route.matched.find((f) => f.meta.menuId !== undefined);
    return Boolean(item && (await this.checkItem(item.meta.menuId, 65536)));
  },
};
